// Texty stránky Doprava a platba (shippingPage.js). Čísla (pásma, ceny, cut-off,
// dopravci) jdou z modelu parametry — věty je jen skládají.
import { NBSP } from '../../modules/money.js';

const KG = NBSP + 'kg';
// páteční uzávěrka jako dovětek („ (v pátek do 14:30)"); se stejným časem nic
const friNote = (v) => (v.cutoffFri === v.cutoff ? '' : ' (v pátek do ' + v.cutoffFri + ')');

export default {
  eyebrow: 'Doručení a platba',
  /** perex hera; v = { maxKg, freeFrom, scope, cutoff, cutoffFri } */
  perex: (v) =>
    'Cena dopravy se řídí hmotností zásilky ve třech pásmech po ' +
    v.maxKg +
    KG +
    '. Lehké balíky nad ' +
    v.freeFrom +
    ' vezeme ' +
    v.scope +
    ' zdarma, objednávky do ' +
    v.cutoff +
    friNote(v) +
    ' odesíláme ještě ten den – a o víkendu se u nás nečeká: v sobotu doručuje GLS, v neděli sváží PPL.',
  /** řádek faktů pod perexem */
  facts: (v) => [
    'Doprava od ' + v.fromPrice,
    'Zdarma ' + v.scope + ' nad ' + v.freeFrom + ' do ' + v.maxKg + KG,
    'Do ' + v.cutoff + friNote(v) + ' objednáte, dnes odešleme',
    'Osobní odběr v Bílině zdarma, i o víkendu',
  ],

  // kalkulačka
  calcTitle: 'Kolik zaplatíte za dopravu',
  calcHint: 'Stejný ukazatel pásem uvidíte i v košíku u výběru dopravy',
  calcWeightLabel: 'Kolik váží zásilka?',
  calcWeightHint: 'Hmotnost je u každého produktu v parametrech; v košíku se položky sčítají.',
  calcValueLabel: 'Hodnota objednávky',
  calcUnder: (freeFrom) => 'do ' + freeFrom,
  calcOver: (freeFrom) => 'nad ' + freeFrom,

  // ceník
  priceTitle: 'Ceník po pásmech',
  /** v = { maxKgDec ('10,00'), maxKg, nextKg } */
  priceLead: (v) =>
    'Pásma jsou uzavřená zdola, otevřená shora: přesně ' +
    v.maxKgDec +
    KG +
    ' už patří do pásma ' +
    v.maxKg +
    '–' +
    v.nextKg +
    KG +
    '. Rozhoduje součet hmotností položek v košíku. Ceny jsou s DPH a platí pro celou ČR.',
  priceSub: 'výdejní místo / adresa',
  priceSubLimited: 'výdejní místo (jen PPL) / adresa',
  priceSubOver: 'jen Fofr, na adresu',
  priceFreeSum: (freeFrom) => 'nad ' + freeFrom + ' výdejní místo zdarma',
  priceFreeCell: (freeFrom) => 'zdarma nad ' + freeFrom,
  priceMethod: 'Metoda',
  priceNote: (v) =>
    'Doprava zdarma platí jen v pásmu do ' +
    v.maxKg +
    KG +
    ' a jen ' +
    v.scope +
    '. Atypické zboží je v košíku označené a veze ho jen nadrozměrná přeprava; ' +
    'zásilky nad limity dopravců jedou na paletě a cenu spočítáme individuálně.',
  free: 'Zdarma',
  /** popisek pásma: „do 10 kg", „nad 30 kg" (předložka zvlášť, skrývá se na mobilu) */
  bandUpTo: 'do ',
  bandOver: 'nad ',
  cellLimit: (kg) => 'jen do ' + kg + KG,
  cellOver: (kg) => 'nad ' + kg + KG + ' neveze',
  /** akce na dopravu (#322): poznámka buňky ceníku, souhrn pásma a pruh v heru */
  cellPromo: (until) => 'akce do ' + until,
  /** akce jen v části pásma (PPL 49 do 2 kg): „49 Kč do 2 kg, akce do 30. 11." */
  cellPromoPart: (price, kg, until) => price + ' do ' + kg + KG + ', akce do ' + until,
  /** „PPL 19 Kč do 25. 10.", akce v části pásma „PPL 49 Kč do 2 kg, akce do 30. 11." */
  sumPromo: (carrier, price, maxKg, until) =>
    carrier + ' ' + price + (maxKg ? ' do ' + maxKg + KG + ', akce' : '') + ' do ' + until,
  heroPromo: (carrier, price, maxKg, until) =>
    'Akce do ' + until + ': ' + carrier + ' na výdejní místo za ' + price + ' u zásilek do ' + maxKg + KG + '.',
  /** druhý dopravce sloučené řádky ceníku na mobilu („PPL a GLS na adresu") */
  mergeSuffix: ' a GLS',

  // termíny
  etaTitle: 'Kdy balík dorazí',
  /** v = { cutoff, cutoffFri } */
  etaHint: (v) =>
    'Zboží skladem, uzávěrka expedice ' +
    v.cutoff +
    (v.cutoffFri === v.cutoff ? '' : ', v pátek ' + v.cutoffFri) +
    ' · přesný termín vidíte u produktu i v košíku',
  /** zkratky dnů týdenního pásu Čt → Út */
  weekDays: ['Čt', 'Pá', 'So', 'Ne', 'Po', 'Út'],
  dispatch: (cutoff) => 'expedujeme do ' + cutoff,
  /** pruh skladu přes čtvrtek a pátek; v = { cutoff, cutoffFri } */
  dispatchFri: (v) => 'expedujeme do ' + v.cutoff + (v.cutoffFri === v.cutoff ? '' : ', v pátek do ' + v.cutoffFri),
  weekend: 'víkend – neexpedujeme',
  rowStock: 'Sklad',
  rowSat: 'sobota',
  rowSun: 'neděle',
  satOrder: 'objednáte',
  satShip: 'odešleme',
  satDeliver: 'doručíme v sobotu',
  satDeliverShort: 'sobota',
  sunOrder: 'objednáte do sobotní půlnoci',
  sunShip: 'svoz v neděli',
  sunShipShort: 'svoz',
  sunDeliver: 'doručíme v pondělí',
  sunDeliverShort: 'pondělí',
  others: 'ostatní dopravci',
  othersShort: 'ostatní',
  legend: ['expedice skladu', 'objednáte', 'odešleme', 'doručíme'],

  // jízdní řád; v = { cutoff, cutoffFri, sat, sun } (sat/sun = jméno dopravce)
  schedHead: ['Objednáte', 'Odešleme', 'Doručíme'],
  schedRows: (v) => [
    {
      when: v.cutoffFri === v.cutoff ? 'Po–Pá do ' + v.cutoff : 'Po–Čt do ' + v.cutoff + ', Pá do ' + v.cutoffFri,
      ship: 'ještě dnes',
      eta: 'následující pracovní den',
    },
    { when: 'Po–St po ' + v.cutoff, ship: 'další pracovní den', eta: 'den poté' },
    {
      when: 'Čt ' + v.cutoff + ' – Pá ' + v.cutoffFri,
      fast: 'sat',
      whenNote: v.sat + ' na adresu i na výdejní místo',
      ship: 'v pátek',
      eta: 'v sobotu s ' + v.sat,
      etaFast: true,
      etaNote: 'ostatní dopravci v pondělí',
    },
    {
      when: 'Pá ' + v.cutoffFri + ' – So 24:00',
      fast: 'sun',
      whenNote: v.sun + ' na adresu i na výdejní místo',
      ship: 'v neděli s ' + v.sun,
      shipNote: 'ostatní dopravci v pondělí',
      eta: 'v pondělí s ' + v.sun,
      etaFast: true,
      etaNote: 'ostatní dopravci v úterý',
    },
    { when: 'Neděle', ship: 'v pondělí', eta: 'v úterý' },
  ],
  schedNote:
    'Platí pro zboží skladem; svátky se do expedice nepočítají a svátek v neděli ' +
    'nebo v pondělí nedělní svoz ruší. Zboží, které není skladem, má termín uvedený ' +
    'na detailu produktu. V pokladně je rychlejší dopravce v daném okně vždy první ' +
    'se štítkem Nejrychlejší.',
  /** prefixy řádku jízdního řádu na mobilu */
  schedPreShip: 'odešleme ',
  schedPreEta: 'doručíme ',

  // dopravci a platby
  carriersTitle: 'Dopravci a odběr',
  /** limity dopravce; box = strop výdejních míst, last = strop adresy */
  limits: (box, last) => 'výdejní místa do ' + box + KG + ', adresa do ' + last + KG,
  limitsOver: (last) => 'nad ' + last + KG + ', jen na adresu',
  /** texty karet dopravců ({ b } = tučně) */
  glsText: [
    'Tisíce výdejních míst a GLS boxů po celé ČR. V den převzetí od nás přijde SMS ' +
      's číslem zásilky, kurýr na adresu v den doručení volá. ',
    { b: 'Doručuje i v sobotu' },
    ' – balík odeslaný v pátek máte druhý den.',
  ],
  pplText: [
    'Parcelshopy a Parcelboxy včetně boxů třetích stran. ',
    { b: 'Nedělní svoz' },
    ' – objednávku z víkendu má PPL v pondělí u vás. Nadrozměrná přeprava PPL veze ' +
      'atypické zboží; na některých výdejních místech PPL jde dobírku zaplatit jen ' +
      'přes aplikaci PPL.',
  ],
  fofrText: (last, price) => [
    'Nadměrné balíky nad ' +
      last +
      KG +
      ' za ' +
      price +
      '. Výdejní místa ani běžná doprava se u nich nenabízejí, košík metodu zvolí sám. ' +
      'Zboží nad limity dopravců jede na paletě – cenu spočítáme individuálně a ozveme ' +
      'se hned po přijetí objednávky.',
  ],
  pickupName: 'Osobní odběr',
  pickupFree: 'zdarma',
  /** place = adresa prodejny, hours = otevírací doba */
  pickupText: (place, hours) => [
    'Prodejna Jipos, ',
    { b: place },
    ' · ' +
      hours +
      '. Zboží skladem si můžete vyzvednout bez dlouhého čekání. Stačí na prodejně nahlásit číslo objednávky a během pár minut vám ho přineseme ze skladu.',
  ],

  payTitle: 'Platba',
  payHint: 'Jen dobírka je zpoplatněná',
  /** názvy plateb (paymentIcon() podle nich volí ikonu) a popisy; pořadí = karta, převod, dobírka, prodejna */
  payments: [
    {
      name: 'Kartou online',
      desc:
        'Visa, Mastercard, Apple Pay, Google Pay · brána Shoptet Pay, zboží skladem ' +
        'expedujeme hned',
    },
    {
      name: 'Bankovním převodem / QR platbou',
      desc: 'údaje včetně QR kódu pošleme po objednávce, odesíláme po připsání částky',
    },
    {
      name: 'Dobírkou',
      desc:
        'při převzetí kurýrovi nebo na výdejním místě; některá výdejní místa PPL jen ' +
        'přes aplikaci PPL',
    },
    { name: 'Hotově nebo kartou na prodejně', desc: 'při osobním odběru v Bílině' },
  ],

  contactTitle: 'Nevíte si rady s dopravou těžkého nebo rozměrného zboží?',
  contactText:
    'Napište nám nebo zavolejte, doporučíme dopravu podle hmotnosti a rozměrů ' +
    'a u palet spočítáme cenu předem.',
  /** při vypnutých telefonech bez výzvy k hovoru */
  contactTextNoPhone:
    'Napište nám, doporučíme dopravu podle hmotnosti a rozměrů ' +
    'a u palet spočítáme cenu předem.',
};
